module.exports = __webpack_public_path__ + "static/img/相关查询- banner@2x.34202c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/相关查询- banner@2x.png
// module id = 830
// module chunks = 0